/** Only this email may request a login link on production (doggos.com). */
export const PRODUCTION_ALLOWED_LOGIN_EMAIL = 'jacqueline@doggos.com'

export function normalizeLoginEmail(email) {
  return String(email || '').trim().toLowerCase()
}

export function isProductionAllowedLoginEmail(email) {
  return normalizeLoginEmail(email) === PRODUCTION_ALLOWED_LOGIN_EMAIL
}
